/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '../../../../../assets';
import { BALANCE_SYNC } from '../../../../../modules/app/Api';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { updateRowsStart } from '../../../../Table/actions/tableActions';
import { TTableButtonsGetTranslation, TTableButtonsUpdateTimer } from '../useTableFooterButtons';

const useTableFooterButtonUpdateBalance = (
    getTranslation: TTableButtonsGetTranslation,
    updateTimer: TTableButtonsUpdateTimer,
) => {
    const dispatch = useDispatch();

    return {
        className: 'table-footer__link link-update-balance',
        dataName: 'update-balance',
        icon: icons.refreshIcon,
        id: AccessComponentKeyEnum.FooterButtonBalanceUpdate,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonBalanceUpdate),

        onClick: useCallback(() => {
            dispatch(updateRowsStart({ method: 'POST', url: BALANCE_SYNC }));
            updateTimer(AccessComponentKeyEnum.FooterButtonBalanceUpdate);
        }, [dispatch, updateTimer]),
    };
};

export default useTableFooterButtonUpdateBalance;
